import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ChartDonut from '../components/Chart/ChartDonut';
import ChartColumn from '../components/Chart/ChartColumn';
import CardOverView from '../components/Card/CardOverView';
import dayjs from 'dayjs';
import {
  Grid,
  TextField,
  Button,
  Tabs,
  Tab,
  Card,
  Box,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
} from '@mui/material';
import { TabPanel, TabContext } from '@mui/lab';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers';
import { lowerCase } from 'lodash';

import {
  initializeSocket,
  getSocket,
  disconnectSocket,
} from '../components/Socket/SocketComponent';
import AdminListApi from '../service/admin.api';

const textFieldStyles = {
  '& fieldset': {
    borderRadius: 30,
  },
};

function Dashboard() {
  const [dataDashboard, setDataDashboard] = useState([]);
  const [detailCards, setDetailCards] = useState([]);
  const [detailChartDonut, setDetailChartDonut] = useState([]);
  const [detailChartColumn, setDetailChartColumn] = useState([]);
  const [startDate, setStartDate] = useState(
    dayjs().subtract(1, 'month').startOf('day'),
  );
  const [endDate, setEndDate] = useState(dayjs().endOf('day'));
  const [search, setSearch] = useState('month');
  const [date, setDate] = useState('Month');

  const handleChangeDayMonth = (event) => {
    setDate(event.target.value);
    setSearch(lowerCase(event.target.value));
  };

  const getDataDashboard = async () => {
    const start = dayjs(startDate).format('YYYY-MM-DD');
    const end = dayjs(endDate).format('YYYY-MM-DD');
    try {
      const data = await AdminListApi.getDashboardDataApi(search, start, end);
      console.log('data dashboard: ', data.data);

      // Example of setting data (no changes here)
      setDataDashboard([data.data]);
      setDetailCards([
        {
          title: 'จำนวนบิลทั้งหมด',
          color: '#008FFB',
          value: data.data['sum_all_payment'],
          money: data.data['total_all_money']
            ? data.data['total_all_money']
            : '',
        },
        {
          title: 'บิลที่จ่ายแล้ว',
          color: '#00E396',
          value: data.data['sum_success_payment'],
          money: data.data['total_success_money']
            ? data.data['total_success_money']
            : '',
        },
        {
          title: 'บิลที่ยังไม่จ่าย',
          color: '#FEB019',
          value: data.data['sum_open_payment']['sum_no_late'],
          money: data.data['total_open_money_no_late']
            ? data.data['total_open_money_no_late']
            : '',
        },
        {
          title: 'บิลที่เกินกำหนด',
          color: '#FF4560',
          value: data.data['sum_open_payment']['sum_late'],
          money: data.data['total_open_money_late']
            ? data.data['total_open_money_late']
            : '',
        },
      ]);
      setDetailChartDonut([
        {
          title: 'บิลที่จ่ายแล้ว',
          color: '#00E396',
          value: data.data['sum_success_payment'],
        },
        {
          title: 'บิลที่ยังไม่จ่าย(ยังไม่เกินกำหนด)',
          color: '#FEB019',
          value: data.data['sum_open_payment']['sum_no_late'],
        },
        {
          title: 'บิลที่เกินกำหนด(ยังไม่จ่าย)',
          color: '#FF4560',
          value: data.data['sum_open_payment']['sum_late'],
        },
      ]);
      setDetailChartColumn([data.data.data]);
    } catch (e) {
      console.error('Error fetching dashboard data:', e.message);
    }
  };

  const onClickSearch = () => {
    getDataDashboard();
  };

  useEffect(() => {
    getDataDashboard();
  }, [search]);

  useEffect(() => {
    const socket = initializeSocket();

    socket.on('paymentSuccess', (data) => {
      console.log('Payment Success Event:', data);

      const paymentDate = dayjs(data.paymentDate);
      const start = dayjs(startDate);
      const end = dayjs(endDate);

      if (paymentDate.isAfter(start) && paymentDate.isBefore(end)) {
        console.log('Payment date is within the range:', data.paymentDate);
        getDataDashboard();
      }
    });

    return () => {
      // Remove event listener on unmount
      socket.off('paymentSuccess');
      disconnectSocket();
    };
  }, []);

  // const detailsDatePicker = [
  //   {
  //     title: 'Day',
  //     view: ['day', 'month', 'year'],
  //     inputFormat: 'DD-MM-YYYY',
  //   },
  // ];
  return (
    <div className="container">
      <div className="mb-4">Dashboard</div>
      <div className="flex">
        <Grid container spacing={1}>
          <Grid item xs={4} md={3} lg={2}>
            <Box>
              <FormControl fullWidth>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={date}
                  onChange={handleChangeDayMonth}
                  sx={{ height: '40px', ...textFieldStyles }}
                >
                  <MenuItem value={'Day'}>Day</MenuItem>
                  <MenuItem value={'Month'}>Month</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={4} md={3} lg={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="วันที่"
                value={startDate}
                views={['year', 'month', 'day']}
                inputFormat={'YYYY-MM-DD'}
                maxDate={endDate}
                onChange={(newValue) => {
                  setStartDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    sx={{ ...textFieldStyles }}
                    size="small"
                    {...params}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={4} md={3} lg={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              {startDate === null || startDate === '' ? (
                <DatePicker
                  disabled
                  label="ถึง"
                  views={['year', 'month', 'day']}
                  inputFormat={'YYYY-MM-DD'}
                  value={endDate}
                  minDate={startDate}
                  onChange={(newValue) => {
                    setEndDate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      sx={{ ...textFieldStyles }}
                      {...params}
                    />
                  )}
                />
              ) : (
                <DatePicker
                  label="ถึง"
                  views={['year', 'month', 'day']}
                  inputFormat={'YYYY-MM-DD'}
                  value={endDate}
                  minDate={startDate}
                  onChange={(newValue) => {
                    setEndDate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      sx={{ ...textFieldStyles }}
                      {...params}
                    />
                  )}
                />
              )}
            </LocalizationProvider>
          </Grid>
          <Grid item xs={4} md={2} lg={1}>
            <div className="">
              <Button
                variant="contained"
                sx={{
                  background: 'primary',
                  color: 'white',
                  borderRadius: '20px',
                }}
                onClick={() => {
                  onClickSearch();
                }}
              >
                ค้นหา
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
      <div style={{ marginTop: '10px' }}>
        {' '}
        <CardOverView data={detailCards} />
      </div>
      <div className="mt-4">
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={6}>
            <Card
              variant="outlined"
              sx={{
                height: '210px',
                backgroundColor: '#F5F6FA',
                border: 'none',
                borderRadius: '10px',
                borderColor: '#5cc1a9',
                borderStyle: 'solid',
              }}
            >
              <ChartDonut data={detailChartDonut} />
            </Card>
          </Grid>
          <Grid item xs={12} md={12} lg={6}>
            <Card
              variant="outlined"
              sx={{
                height: '210px',
                border: 'none',
                borderRadius: '10px',
                borderColor: '#5cc1a9',
                borderStyle: 'solid',
              }}
            >
              <ChartColumn data={detailChartColumn} />
            </Card>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default Dashboard;
